module.exports = ReduxThunk;


//////////////////
// WEBPACK FOOTER
// external "ReduxThunk"
// module id = 44
// module chunks = 0